import {
  FilterTypeEnum,
  FilterUIPlacementEnum,
  IFilter,
  FilterOffer,
  FilterSelection,
  FilterUISubPlacementEnum,
} from './types';

export const getFiltersConfig = (): IFilter[] => {
  return [
    {
      label: 'sort.price_includes_shipping',
      type: FilterTypeEnum.PRICES_INC_SHIPPING,
      placement: FilterUIPlacementEnum.OFFERLIST_HEADER,
      filterFn: (offer: FilterOffer) => {
        return Boolean(offer?.price?.inclShipping);
      },
      missingInfoFn: (offer: FilterOffer) => {
        return !offer?.price?.inclShipping;
      },
      filterAlternativeOffers: true,
      active: false,
      treatUnfeaturedAsMissingInfo: true,
    },
    {
      label: 'stock-status.in_stock',
      type: FilterTypeEnum.IN_STOCK,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      subPlacement: FilterUISubPlacementEnum.SHOW_ONLY,
      filterFn: (offer: FilterOffer) => {
        return Boolean(offer?.stock?.status === 'in_stock');
      },
      missingInfoFn: (offer: FilterOffer) => {
        return Boolean(
          !offer?.stock?.status || offer?.stock?.status === 'unknown'
        );
      },
      filterAlternativeOffers: true,
      active: false,
      treatUnfeaturedAsMissingInfo: true,
    },
    {
      label: 'price-filter.featured-shops',
      type: FilterTypeEnum.FEATURED_SHOP,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      subPlacement: FilterUISubPlacementEnum.SHOW_ONLY,
      filterFn: (offer: FilterOffer) => {
        return Boolean(offer && 'store' in offer && offer.store?.featured);
      },
      filterAlternativeOffers: false,
      active: false,
    },
    {
      label: 'price-filter.authorized-dealer',
      type: FilterTypeEnum.AUTHORIZED_DEALER,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      subPlacement: FilterUISubPlacementEnum.SHOW_ONLY,
      filterFn: (offer: FilterOffer) => {
        return Boolean(
          offer && 'authorizedDealer' in offer && offer.authorizedDealer
        );
      },
      filterAlternativeOffers: false,
      active: false,
    },
    {
      label: 'price-filter.pickup-only',
      type: FilterTypeEnum.PICKUP_ONLY,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      subPlacement: FilterUISubPlacementEnum.ADDITIVE,
      filterFn: (offer: FilterOffer) => {
        return Boolean(offer && offer?.type !== 'pickup_only');
      },
      filterAlternativeOffers: false,
      active: true,
      additive: true,
    },
    {
      label: 'price-filter.international',
      type: FilterTypeEnum.INTERNATIONAL,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      subPlacement: FilterUISubPlacementEnum.ADDITIVE,
      filterFn: (offer: FilterOffer) => {
        return Boolean(
          offer && 'store' in offer && offer?.store?.market === 'primary'
        );
      },
      filterAlternativeOffers: false,
      active: true,
      additive: true,
    },
    {
      label: 'price-filter.not-for-sale',
      type: FilterTypeEnum.NOT_FOR_SALE,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      subPlacement: FilterUISubPlacementEnum.ADDITIVE,
      filterFn: (offer: FilterOffer) => {
        return Boolean(offer && offer?.type !== 'not_available_for_purchase');
      },
      filterAlternativeOffers: false,
      active: true,
      additive: true,
    },
    {
      label: '',
      type: FilterTypeEnum.VARIANT_SIZE,
      placement: FilterUIPlacementEnum.PRODUCT_HEADER,
      filterFn: (offer: FilterOffer, selection?: FilterSelection) => {
        return Boolean(
          offer &&
            offer?.variantInfo?.size &&
            selection?.includes(offer.variantInfo.size)
        );
      },
      missingInfoFn: (offer: FilterOffer) => {
        return !offer?.variantInfo?.size;
      },
      filterAlternativeOffers: true,
      active: false,
      selection: [],
      initialSelection: [],
    },
    {
      label: '',
      type: FilterTypeEnum.CONDITION,
      placement: FilterUIPlacementEnum.PRODUCT_HEADER,
      filterFn: (offer: FilterOffer, selection?: FilterSelection) => {
        return Boolean(
          offer?.condition && selection?.includes(offer?.condition)
        );
      },
      filterAlternativeOffers: true,
      active: true,
      selection: ['new'],
      initialSelection: ['new'],
    },
  ];
};
